"use client";

import { useState } from "react";
import { API_URL } from "../../utils/common";

export interface AdminPermiso {
    id: number;
    nombre: string;
    descripcion: string;
    sufijo: string;
    estatus: number | string;
}

export const useGetAdminUserPermisos = () => {

    const [permisos, setPermisos] = useState<AdminPermiso[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getToken = () => localStorage.getItem("jwt");

    const obtenerPermisos = async () => {

        setLoading(true);
        setError(null);

        try {

            const token = getToken();

            if (!token) {
                throw new Error("Token no encontrado");
            }

            const response = await fetch(`${API_URL}/cms/admin/permisos`, {
                method: "GET",
                headers: {
                    Authorization: `bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Error al obtener permisos");
            }

            const data = await response.json();

            setPermisos(data);

        } catch (err: any) {

            console.error(err);
            setError(err.message || "Ocurrió un error");

        } finally {

            setLoading(false);

        }
    };

    return {
        permisos,
        loading,
        error,
        obtenerPermisos,
    };
};